'use client';

import { datadogLogs, type LogsInitConfiguration } from '@datadog/browser-logs';
import { useEffect } from 'react';

interface DatadogLogsInitProps {
    config: LogsInitConfiguration;
    enabled?: string | undefined;
}

export default function DatadogLogsInit({ config, enabled }: DatadogLogsInitProps): null {
    useEffect(() => {
        if (enabled !== 'true') return;
        if (datadogLogs.getInitConfiguration()) return; // Already initialized by another instance

        // note: no PII redaction at this point. if and when we add it, it should be merged into config as a
        // `beforeSend` callback. it must live client-side — Datadog invokes `beforeSend` synchronously per log event
        // in the browser, so it can't be a server action. its type is LogsBeforeSend from the browser-logs pkg
        datadogLogs.init(config);
    }, [config, enabled]);

    return null;
}
